import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import { App } from './App';
import { bootstrapApp } from './app/bootstrap';
import { store } from './app/store';
import './index.css';

/**
 * The entry point does two things and nothing else: run the boot sequence,
 * then mount.
 *
 * Every ordering constraint that matters — device identity before the queue,
 * locale before the first paint, the queue before the scheduler — lives in
 * `app/bootstrap.ts`, where it has a test. A `void bootstrap()` at the bottom
 * of an entry file cannot be imported and therefore cannot be asserted on.
 */
async function main(): Promise<void> {
  const container = document.getElementById('root');
  if (container === null) throw new Error('index.html is missing #root');

  const { i18n } = await bootstrapApp();

  createRoot(container).render(
    <StrictMode>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </Provider>
    </StrictMode>,
  );
}

void main();
